
export default {
	clearError(context) {
		context.commit('CLEAR_ERROR');
	},
}
